// extracted by mini-css-extract-plugin
export var brand = "_7p-8";
export var compact = "_7p-5";
export var extraSmall = "_7p-6";
export var icon = "_7p-0";
export var large = "_7p-3";
export var light = "_7p-1";
export var medium = "_7p-4";
export var outline = "_7p-a";
export var primaryDark = "_7p-9";
export var primaryLight = "_7p-7";
export var primaryModern = "_7p-b";
export var success = "_7p-2";